import api from '../config/api';
import { Institution, InstitutionDto } from '../types/institution';
import { ChangeRequest } from '../types/changeRequest';
import { CommitteeCreate } from '../types/committee';
import { PagedResponse } from '../types/member';

export const institutionService = {
  getMyInstitution: async (): Promise<InstitutionDto> => {
    const response = await api.get<InstitutionDto>('/institutions/me');
    return response.data;
  },

  updateMyInstitution: async (
    institution: Partial<InstitutionDto>
  ): Promise<ChangeRequest[]> => {
    const response = await api.put<ChangeRequest[]>(
      '/institutions/me',
      institution
    );
    return response.data;
  },

  addCommittee: async (committee: CommitteeCreate): Promise<void> => {
    await api.post('/institutions/me/committees', committee);
  },

  removeCommittee: async (committeeId: string): Promise<void> => {
    await api.delete(`/institutions/me/committees/${committeeId}`);
  },

  getInstitutions: async (
    params: {
      page?: number;
      pageSize?: number;
      search?: string;
    } = {}
  ): Promise<PagedResponse<Institution>> => {
    const response = await api.get<PagedResponse<Institution>>(
      '/admin/institutions',
      { params }
    );
    return response.data;
  },
};
